import React, { useContext } from 'react';
import {
    FormDataConsumer,
    RichTextField,
    ReferenceField,
    ReferenceInput,
    TextField,
    FormTab,
    Tab,
    DateField,
    BooleanField,
    NumberField,
    SimpleFormIterator,
    ArrayField,
    Datagrid,
    useRecordContext,
    useResourceContext,
    choices,
    Button,
    maxLength,
    useDataProvider,
    required,
    ArrayInput as RaArrayInput
} from "react-admin";
import { Typography, Box, Divider, Chip, Button as MUIButton } from '@mui/material';

import ModuleVersionLinkField from "../../../lib/ModuleVersionLinkField";
import ModuleLanguageLinkField from '../../../lib/ModuleLanguageLink';
import { ModuleTitleRenderer } from '../../Course/CourseInputs';
import VeroChipField from "../../../lib/VeroChipField";
import {
    DateInput,
    TextInput,
    RichTextInput,
    NumberInput,
    BooleanInput,
    ArrayInput,
    AutocompleteInput,
    SelectInput} from '../../../lib/wrappers/Inputs';
import { CourseLinkField } from "../ModuleList";
import { StaffInput } from "../../Common/StaffInput";
import { validDatesValidation } from "../../../lib/CommonComponents";
import { VersioningTypeInput } from "../../../lib/VersioningTypeInput";
import { ReadOnlyContext } from '../../../lib/context/ReadOnlyContext';
import { useAzureADGroups } from '../../../msal/useAzureADGroups';
import { useParams } from 'react-router-dom';

const LengthCheck = maxLength(80, "Please check length of title field");

var titleStyle = { color: "#AE223F" }
var labelStyle = {
    color: '#000000',
    opacity: 0.8,
    padding: 0,
    fontsize: 1,
    fontweight: 400, lineheight: 1, letterspacing: 0.00938
}

function compareDates(setDate) {
    // Get today's date
    const today = new Date();
  
    // Parse the provided set date string into a Date object
    const parsedSetDate = new Date(setDate);
  
    // Compare the two dates
    if (isNaN(parsedSetDate.getTime())) {
      // Invalid date string
      return false;
    } 
    // Today is before the set date.
    else if (today < parsedSetDate) {
      return false;
    } 
    // Today is after the set date.
    else if (today > parsedSetDate) {
      return true;
    } 
    //Today is the same as the set date.
    else {
      return true;
    }
  }

export const ModuleInformationInputTab = (props) => {
    const resource = useResourceContext();
    const record = useRecordContext();
    const dataProvider = useDataProvider();
    const setDate = "2023-08-14";
    const readonly = useContext(ReadOnlyContext) || false
    const { isHeadOfSubject } = useAzureADGroups();
    let isHistoric = false;
    const params = useParams();
    if(params.id?.length > 10){
        isHistoric = true;
    }

    const facFilter = () => {
        if(compareDates(setDate)){
            return {isAcademic: true, current: true, structureId: '2'};
        }
        else{
            return {isAcademic: true, current: true};
        }
    }

    const handlePDF = async () => {
        try {
          //build Id
          const id = record?.veroId + "-" + record?.version;
          // Use the dataProvider to make API requests
          const additionalData = await dataProvider.getOne('PDFSpec', { id: id});
          ///use data 
          console.log('Additional Data:', additionalData);
        } catch (error) {
          console.error('Error fetching additional data:', error);
        }
      };

    return <FormTab {...props} label="myroot.moduleInformation">
        <Box display="flex" width={1}  sx={{ height: '40px', borderBottom: '1px solid #AE223F', marginBottom: '15px', paddingBottom: '10px'  }}>
            <Box flex={4}>
                <Typography variant="h6" style={titleStyle}>
                    Module | <small><TextField source="id" label={false} /></small> | <small><TextField source="shortTitle" label={false} /></small>
                </Typography>
            </Box>
            <Box flex={2} display="flex" justifyContent="flex-end" >   
                {record?.id && <Button variant="outlined" href={"https://southwales.rl.talis.com/search.html?q=" + record?.moduleCode} target="_blank" label="Reading list " />}
            </Box>            
            <Box flex={2} display="flex" justifyContent="flex-end">                
                {record?.id && <CourseLinkField label="Courses using module" source="id" />}
            </Box>
            <Box flex={2} display="flex" justifyContent="flex-end" >
                <MUIButton variant="outlined" onClick={handlePDF} label="Send Module Spec PDF"> Send Module PDF</MUIButton>
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
            {(resource === "Module" && record?.id)
                    ? <ModuleVersionLinkField source="version" id={record?.id} />
                    : (record?.id && <TextField source="version" />)
                }
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="General" /></b></Divider>
            </Box>
        </Box>
        <Box display='flex' width={1}>
            <Box flex={4}>
            {resource === 'Module' && (record?.statusId === 'STS000012' || record?.statusId === undefined || record?.id === undefined) ? (
                    <TextInput source="shortTitle" label="Module Title" validate={[required(), LengthCheck]}  fullWidth />
                ) : (
                    <TextInput source="shortTitle" label="Module Title" validate={[required(), LengthCheck]} disabled fullWidth />
                )}                
            </Box>
            <Box flex={2} ml="0.5em">
                <TextInput source="moduleCode" fullWidth />
            </Box>
            <Box flex={1} ml="0.5em">
                <DateInput source="validationFrom" fullWidth validate={required()} />
            </Box>
            <Box flex={1} ml="0.5em">
                <DateInput source="validationTo" fullWidth  validate={[required(), validDatesValidation]}/>
            </Box>
        </Box>

        <Box display='flex' width={1}>
            <Box flex={3}>
                <DateInput source="firstIntendedIntake" fullWidth />
            </Box>
            <Box flex={3} ml="0.5em">
                <DateInput source="finalYearOfIntake" fullWidth />
            </Box>
            <Box flex={3} ml="0.5em">
                <DateInput source="closedDate" fullWidth />
            </Box>
        </Box>

        <Box display='flex' width={1}>
            <Box flex={3}>
                <ReferenceInput label="Faculty" reference="Faculty" source="facultyId" fullWidth filter={facFilter()}>
                    <AutocompleteInput optionText={optionTextFaculty} />
                </ReferenceInput>
            </Box>
            <Box flex={3} ml="0.5em">
                <FormDataConsumer>
                    {({ formData, ...rest }) => formData.facultyId ?
                        <ReferenceInput reference="FacultyGroup"
                            label="myroot.FacultyGroup"
                            source="departmentId"
                            filter={{ faculty_id: formData.facultyId }}
                            {...rest} fullWidth>
                            <AutocompleteInput optionText="description" />
                        </ReferenceInput>
                        : null}
                </FormDataConsumer>
            </Box>
            <Box flex={3} ml="0.5em">
                <FormDataConsumer>
                    {({ formData, ...rest }) => formData.departmentId ?
                        <ReferenceInput reference="FacultySubGroup"
                            label="myroot.FacultySubGroup"
                            source="subjectId"
                            filter={{ facultygroup_id: formData.departmentId }}
                            {...rest} fullWidth>
                            <AutocompleteInput optionText="description" />
                        </ReferenceInput>
                        : null}
                </FormDataConsumer>
            </Box>
        </Box>

        <Box display='flex' width={1}>
            <Box flex={2}>
                <ReferenceInput reference="CreditValue" source="creditValueId" fullWidth filter={{ current: true }}>
                    <SelectInput optionText="creditvalue" fullWidth />
                </ReferenceInput>
            </Box>
            <Box flex={2} ml="0.5em">
                <ReferenceInput reference="CreditLevel" source="creditLevelId" fullWidth filter={{ current: true }}>
                    <AutocompleteInput optionText="Title" fullWidth/>
                </ReferenceInput>
            </Box>
            <Box flex={2} ml="0.5em">
                <ReferenceInput label="Language" reference="Language" source="languageId" defaultValue="LAN000001" fullWidth>
                    <AutocompleteInput optionText="description" />
                </ReferenceInput>
            </Box>
            <Box flex={2} ml="0.5em">
                <ReferenceInput reference="Status" source="statusId" fullWidth>
                    <AutocompleteInput optionText="Title" disabled={props.create} />
                </ReferenceInput>
            </Box>
        </Box>
        <Box display='flex' width={1}>
            <Box flex={2}>
                <NumberInput source="percentageOfModuleTaughtInWelsh" fullWidth />
            </Box>
            <Box flex={2} ml="0.5em">
                <TextInput source="equivalentModule" fullWidth />
            </Box>
            <Box flex={2} ml="0.5em">
                <BooleanInput source="providesEmployability" label="myroot.employability" fullWidth />
            </Box>            
            <Box flex={2} ml="0.5em">
                <BooleanInput source="offersImmersiveLearning" label="myroot.immersiveLearning" fullWidth />            
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Module Leader and Teams" /></b></Divider>
            </Box>
        </Box>
        <Box display='flex' width={1}>
        <Box flex={1} ml="0.5em">
                <Box width={1}>
                    <RaArrayInput source="moduleLeaders" label="Module Leaders (2 max)" validate={maxLength(2)} disabled={(readonly && !isHeadOfSubject) || (readonly && isHistoric)}>
                        <SimpleFormIterator disableReordering fullWidth>
                            <FormDataConsumer>
                                {({ formData, getSource, scopedFormData }) => (
                                    <StaffInput
                                        teamName="moduleLeaders"
                                        formData={formData}
                                        getSource={getSource}
                                        scopedFormData={scopedFormData}
                                    />
                                )}
                            </FormDataConsumer>
                        </SimpleFormIterator>
                    </RaArrayInput>
                </Box>
                <Box width={1}>
                    <RaArrayInput source="moduleTeams" label="Module Teams" disabled={(readonly && !isHeadOfSubject) || (readonly && isHistoric)}>
                        <SimpleFormIterator disableReordering fullWidth>
                            <FormDataConsumer>
                                {({ formData, getSource, scopedFormData }) => (
                                    <StaffInput
                                        teamName="moduleTeams"
                                        formData={formData}
                                        getSource={getSource}
                                        scopedFormData={scopedFormData}
                                    />
                                )}
                            </FormDataConsumer>
                        </SimpleFormIterator>
                    </RaArrayInput>
                </Box>
            </Box>
        </Box>        
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Requisites" /></b></Divider>
            </Box>
        </Box>
        <ArrayInput source="requisites" fullWidth>
            <SimpleFormIterator disableReordering fullWidth>
                <FormDataConsumer>
                    {({ getSource, formData }) =>
                        <Box display="flex" width={1}>
                            <Box flex={2}>
                                <ReferenceInput reference="Module" source={getSource("moduleId")} label='myroot.module' fullWidth>
                                    <AutocompleteInput optionText={ModuleTitleRenderer} fullWidth />
                                </ReferenceInput>
                            </Box>
                            <Box flex={1} ml="0.5em">
                                <AutocompleteInput source={getSource("requisiteType")} label="myroot.requisiteType" choices={[
                                    { id: 'pre-requisite', name: 'myroot.prerequisite' },
                                    { id: 'co-requisite', name: 'myroot.corequisite' }]} fullWidth />
                            </Box>
                        </Box>
                    }
                </FormDataConsumer>
            </SimpleFormIterator>
        </ArrayInput>
        <Box display='flex' width={1}>
            <Box flex={1}>
                <Box display="flex" width={1}>
                    <Box flex={1}>
                        <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Module Aims" /></b></Divider>
                    </Box>
                </Box>
                <RichTextInput source="moduleAims" fullWidth label={false} />
                <Box display="flex" width={1}>
                    <Box flex={1}>
                        <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Content Summary" /></b></Divider>
                    </Box>
                </Box>
                <RichTextInput source="contentSummary" fullWidth label={false} />
                <Box display="flex" width={1}>
                    <Box flex={1}>
                        <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="2030 Curriculum Design Principles - Interdisciplinary Opportunities" /></b></Divider>
                    </Box>
                </Box>
                <RichTextInput source="designPrinciplesInter" fullWidth label={false} helperText="Use this space to outline and interdisciplinary opportunities this module will provide or could provide with support." />
                <Box display="flex" width={1}>
                    <Box flex={1}>
                        <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="2030 Curriculum Design Principles - Additional Information" /></b></Divider>
                    </Box>
                </Box>
                <RichTextInput source="designPrinciples" fullWidth label={false} helperText="Use this space to include any additional information which shows how the 2030 Curriculum Design Principles have been embedded within this module." />
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Box display="flex" width={1}>
                    <Box flex={1}>
                        <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Reading List" /></b></Divider>
                    </Box>
                </Box>
                <RichTextInput source="readingList" fullWidth label={false} />
                <Box display="flex" width={1}>
                    <Box flex={1}>
                        <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Assessment Selection Rationale" /></b></Divider>
                    </Box>
                </Box>
                <RichTextInput source="assessmentSelectionRationale" label={false} fullWidth />
            </Box>
        </Box>
        {resource === "Module" &&
            <VersioningTypeInput source="versioningType" resource={resource} />
        }
    </FormTab>;
}

export const ModuleInformationShowTab = (props) => {
    const record = useRecordContext();
    const resource = useResourceContext();

    return (
        <Tab {...props} label="myroot.moduleInformation">
            <TextField source="shortTitle" />
            <TextField source="moduleCode" />
            <DateField source="validationFrom" />
            <DateField source="validationTo" />

            <RichTextField source="moduleAims" />
            <RichTextField source="contentSummary" />            
            <RichTextField source="designPrinciplesInter"
                label="2030 Curriculum Design Principles - Interdisciplinary opportunities" /> <ReferenceField
                    reference="Faculty" source="facultyId" allowEmpty>
                <TextField source="description" />
            </ReferenceField>
            <RichTextField source="designPrinciples" label="2030 Curriculum Design Principles - Addtional Information" />
            <ReferenceField reference="FacultyGroup" source="departmentId" label="myroot.FacultyGroup">
                <TextField source="description" />
            </ReferenceField>
            <ReferenceField reference="FacultySubGroup" source="subjectId" label="myroot.FacultySubGroup">
                <TextField source="description" />
            </ReferenceField>
            <ReferenceField reference="CreditValue" source="creditValueId">
                <TextField source="creditvalue" />
            </ReferenceField>
            {/* <TextField source="academicSession" /> - TODO: rmeove fields from API using migrations */}
            <NumberField source="percentageOfModuleTaughtInWelsh" />
            <TextField source="equivalentModule" />
            <ReferenceField reference="CreditLevel" source="creditLevelId" linkType="show" allowEmpty>
                <TextField sourse="description" />
            </ReferenceField>
            <ArrayField source="externalExaminers" >
                <ReferenceField reference="ExternalExaminer" source="id">
                    <TextField source="workEmail" label='External Examiner' fullwidth />
                    <TextField source="tenureStart" title="Tenure Start" />
                    <TextField source="tenureEnd" title="Tenure End" />
                </ReferenceField>
            </ArrayField>
            <ReferenceField reference="Status" source="statusId">
                <TextField source="Title" />
            </ReferenceField>
            <BooleanField source="providesEmployability" />
            <BooleanField source="offersImmersiveLearning" />
            <TextField source="moduleLeader" />
            <TextField source="moduleTeam" />
            <ReferenceField reference="ProfessionalBody" source="professionalBodyId" fullWidth>
                <TextField optionText="Title" />
            </ReferenceField>
            <RichTextField source="readingList" />
            <DateField source="firstIntendedIntake" />
            <DateField source="finalYearOfIntake" />
            <DateField source="closedDate" />
            <RichTextField source="assessmentSelectionRationale" label="Assessment Selection Rationale" />
            <ArrayField source="assessmentCriteriaList" fullWidth>
                <Datagrid bulkActionButtons={false}>
                    <ReferenceField reference="Assessment" source="assessmentId" link="show"
                        label="myroot.category">
                        <TextField source="category" />
                    </ReferenceField>
                    <ReferenceField reference="Assessment" source="assessmentId" label="myroot.assessmentType"
                        link="show" style={{ display: 'inline', float: 'left', marginLeft: '20px' }}>
                        <TextField source="assessmentType" />
                    </ReferenceField>
                    <ReferenceField reference="AssessmentTariff" source="assessmentTariffId" label="assessmentTariff" linkType="show" style={{ display: 'inline', float: 'left', marginLeft: '20px' }}>
                        <TextField source="Title" />
                    </ReferenceField>
                    <TextField source="description" label="myroot.description" />
                    <NumberField source="durationInMin" label="myroot.durationInMin" />
                    <NumberField source="wordCount" label="myroot.wordCount" />
                    <NumberField source="weight" label="myroot.weight" />
                    <NumberField source="maximumMark" label="myroot.maximumMark" />
                    <NumberField source="passMark" label="myroot.passMark" />
                    <BooleanField source="isBestOfAssessment" label="myroot.isBestOfAssessment" />
                </Datagrid>
            </ArrayField>
            <ArrayField source="moduleLearningOutcomes" fullWidth>
                <Datagrid bulkActionButtons={false}>
                    <TextField source="Title" label="Title" />
                    <TextField source="description" label="Description" />
                </Datagrid>
            </ArrayField>
            <ReferenceField reference="Language" source="languageId" link="show" allowEmpty>
                <TextField source="description" />
            </ReferenceField>
            <ArrayField source="requisites" label="myroot.requisiteType">
                <Datagrid bulkActionButtons={false}>
                    <ReferenceField source="moduleId" reference="Module" link="show" label="myroot.module">
                        <TextField source="shortTitle" />
                    </ReferenceField>
                    <ReferenceField source="moduleId" reference="Module" link="show" label="myroot.moduleCode">
                        <TextField source="moduleCode" />
                    </ReferenceField>
                    <ReferenceField source="moduleId" reference="Module" link="show" label="myroot.CreditValue">
                        <ReferenceField reference="CreditValue" source="creditValueId" link="show">
                            <TextField source="creditvalue" />
                        </ReferenceField>
                    </ReferenceField>
                    <ReferenceField source="moduleId" reference="Module" link="show" label="myroot.CreditLevel">
                        <ReferenceField reference="CreditLevel" source="creditLevelId" link="show">
                            <TextField source="Title" />
                        </ReferenceField>
                    </ReferenceField>
                    <ReferenceField source="moduleId" reference="Module" link="show" label="myroot.status">
                        <ReferenceField reference="Status" source="statusId" link="show">
                            <TextField source="Title" />
                        </ReferenceField>
                    </ReferenceField>
                    <TextField source="requisiteType" />
                </Datagrid>
            </ArrayField>
            <ModuleLanguageLinkField />
            <RichTextField source="learningOutcomes" />
            {(resource === "Module")
                ? <ModuleVersionLinkField source="version" id={record?.id} />
                : <TextField source="version" />
            }
            <AssessmentMatrix {...props} />
            <VeroChipField source="assessmentBonding" />
            <TextField source="assessmentBondingInfo" />
        </Tab>
    );
};





const bondingChoices = [
    { id: 'Bonded', name: 'Bonded', label: 'A student is not required to pass each element of assessment. A student needs only to achieve a pass mark (usually 40%) overall in order to pass the module.' },
    { id: 'Non-Bonded', name: 'Non-Bonded', label: 'A student is required to achieve a pass mark (usually 40%) overall and a minimum of 30% in each element of assessment (as a significant weakness is classed below 30%) in order to pass the module.' },
    { id: 'Partially Bonded', name: 'Partially Bonded', label: 'A student is required to achieve a pass mark (usually 40%) in the following elements of assessment:' },
];
const optionRenderName = choice => `${choice.name}`;
const optionText = ({ choice }) => `${getByValue(bondingChoices, choice).label}`;
const validateValidation = choices(['validated', 'modified', 'corrected'], 'Please check the forms mandatory fields are complete');

const AssessmentMatrix = () => {
    const record = useRecordContext();

    return (
        <div>

            {record ? <div>
                <Typography style={labelStyle}>Assessment Matrix</Typography>
                <Typography>{record.moduleLearningOutcomes ?
                    <p>{record.moduleLearningOutcomes.length} learning outcomes</p> : null}</Typography>

                <table border="1" style={{ borderCollapse: "collapse" }}>
                    <thead>
                        <tr>
                            <th />
                            {record.moduleLearningOutcomes ?
                                record.moduleLearningOutcomes.map((learningOutcome, index) => {
                                    return (<th key={index} style={{ padding: "2px 5px" }}>{learningOutcome.Title}</th>)
                                }
                                ) : null}
                        </tr>
                    </thead>
                    <tbody>{record.assessmentCriteriaList ?
                        record.assessmentCriteriaList.map((criterion, index) => {
                            var row = GetMatrixMatchesForCriterion(criterion, record.moduleLearningOutcomes, index);
                            return row;
                        }) : null}</tbody>
                </table>
            </div> : null}

        </div>
    );

}

const GetMatrixMatchesForCriterion = (criterion, learningOutcomes, index) => {
    var matches = [];

    if (criterion == null || criterion === undefined)
        return (<td>missing information</td>)
    learningOutcomes?.forEach(learningOutcome => {
        if (criterion.learningOutcomeCodes?.indexOf(learningOutcome.Title) !== -1) {
            matches.push(true);
        } else {
            matches.push(false);
        }
    })
    return <tr key={index}>
        <td style={{ padding: "2px 5px" }}>{criterion.description}</td>
        {matches.map(match => {
            if (match)
                return (<td style={{ textAlign: "center" }}>&#10004;</td>)
            else
                return (<td style={{ textAlign: "center" }}>&#10006;</td>)
        })}</tr>
}

const LearningOutcomeChoices = (learningOutcomeArray) => {
    if (Array.isArray(learningOutcomeArray) && learningOutcomeArray.length) {
        var choices = [];
        var i = 0;
        learningOutcomeArray?.forEach(learningOutcome => {
            if (typeof learningOutcome !== 'undefined' && learningOutcome) {
                var choice = { Title: learningOutcome.Title, description: learningOutcome.description, id: i++ }
                choices.push(choice);
            }
        });
        return choices;
    }
    return [{ id: "No data yet", name: "No data yet" }];
}


function optionLabel(val) {
    if (val != undefined) {
        var obj = getByValue(bondingChoices, val);
        return obj.label;
    }
};

function getByValue(arr, value) {
    for (var i = 0, iLen = arr.length; i < iLen; i++) {
        if (arr[i].id == value) {
            return arr[i];
        }
    }
}

export const optionTextFaculty = choice => `${choice.description}${choice.structureId != '2' ? ' - (Old)' : ''}`;
